var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRadioButtonRoundChecked(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_ionic-ios-radio-button-on",
    "data-name": "Icon ionic-ios-radio-button-on",
    transform: "translate(-3.375 -3.375)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_174",
    "data-name": "Path 174",
    d: "M13.375,4.721a8.65,8.65,0,1,1-6.12,2.534,8.6,8.6,0,0,1,6.12-2.534m0-1.346a10,10,0,1,0,10,10,10,10,0,0,0-10-10Z",
    fill: "#0890fe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_175",
    "data-name": "Path 175",
    d: "M19.788,9.452a7.312,7.312,0,1,0,2.139,5.168A7.262,7.262,0,0,0,19.788,9.452Z",
    transform: "translate(-1.245 -1.245)",
    fill: "#0890fe"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRadioButtonRoundChecked);
export default __webpack_public_path__ + "static/media/radio-button-round-checked.a93fc9681dc84cd7a6929e8a3b11a34f.svg";
export { ForwardRef as ReactComponent };